export default [
  {
    header: 'Orders',
    icon: 'PackageIcon',
    group: 'orders',
    children: [
      {
        title: 'Order Uploads',
        route: 'orders-uploads',
        icon: 'UploadCloudIcon',
      },
      {
        title: 'Create Order',
        route: 'create-order',
        icon: 'PlusIcon',
      },
      {
        title: 'Manual Order',
        route: 'manual-order',
        icon: 'EditIcon',
      },
      {
        title: 'Purchase Orders',
        route: 'purchase-orders',
        icon: 'FileTextIcon',
      },
      {
        title: 'Purchase Order Summary',
        route: 'purchase-order-summary',
        icon: 'ListIcon',
      },
      {
        title: 'Shortage Items',
        route: 'shortage-items',
        icon: 'TrendingDownIcon',
      },
    ],
  },
  {
    header: 'Accounts',
    icon: 'BookIcon',
    group: 'accounts',
    children: [
      {
        title: 'Uploads',
        route: 'uploads',
        icon: 'UploadCloudIcon',
      },
      {
        title: 'Dashboard',
        route: 'dashboard',
        icon: 'SunIcon',
      },
      {
        title: 'Statements',
        route: 'statements',
        icon: 'GridIcon',
      },
      {
        title: 'Print Statements',
        route: 'print-statements',
        icon: 'PrinterIcon',
      },
      {
        title: 'Credit/Debit Notes',
        route: 'credit-debit-notes',
        icon: 'BookOpenIcon',
      },
      {
        title: 'Default Parties',
        route: 'defualt-parties',
        icon: 'StopCircleIcon',
      },
      {
        title: 'Default Parties Requests',
        route: 'default-party-order-requests',
        icon: 'BellIcon',
      },
      {
        title: 'Party Ledger',
        route: 'party-ledger',
        icon: 'ShoppingCartIcon',
      },
      {
        title: 'Compare Ledger',
        route: 'compare-ledger',
        icon: 'ColumnsIcon',
      },
      {
        title: 'Cheques',
        route: 'cheques',
        icon: 'FileIcon',
      },
      {
        title: 'Issued Cheques',
        route: 'issued-cheques',
        icon: 'FileIcon',
      },
      {
        title: 'Outstanding Report',
        route: 'outstanding-report',
        icon: 'ListIcon',
      },
      {
        title: 'Sales & Targets',
        route: 'sales-targets',
        icon: 'TrendingUpIcon',
      },
      {
        title: 'Salary',
        route: 'salary',
        icon: 'DollarSignIcon',
      },
      {
        title: 'Online Payment',
        route: 'online-payments',
        icon: 'CreditCardIcon',
      },
    ],
  },
  {
    header: 'Sales',
    icon: 'ActivityIcon',
    group: 'sales',
    children: [
      {
        title: 'Sales Schedule',
        route: 'sales-schedule',
        icon: 'PhoneCallIcon',
      },
      {
        title: "Today's Bills",
        route: 'todays-bills',
        icon: 'FileTextIcon',
      },
      {
        title: 'Sales Notification',
        route: 'sales-notifications',
        icon: 'BellIcon',
      },
      {
        title: 'Orders ',
        route: 'orders',
        icon: 'PackageIcon',
      },
      {
        title: 'POB ',
        route: 'pob',
        icon: 'LayersIcon',
      },
      {
        title: 'Special Bonus',
        route: 'special-bonus',
        icon: 'GiftIcon',
      },
      {
        title: 'Item Discount',
        route: 'item-discount',
        icon: 'PercentIcon',
      },
      {
        title: 'Mr Directory ',
        route: 'mr-list',
        icon: 'UsersIcon',
      },
      {
        title: 'Monthly Targets',
        route: 'monthly-targets',
        icon: 'TrendingUpIcon',
      },
      {
        title: 'Lead Management',
        route: 'lead-management',
        icon: 'UsersIcon',
      },
    ],
  },
  {
    header: 'Returns',
    icon: 'ArrowDownCircleIcon',
    group: 'returns',
    children: [
      {
        title: 'Supplier Return',
        route: 'supplier-return',
        icon: 'ArrowDownIcon',
      },
      {
        title: 'Supplier Return Summary',
        route: 'supplier-return-summary',
        icon: 'ListIcon',
      },
      {
        title: 'Supplier Return Matrix',
        route: 'supplier-return-matrix',
        icon: 'GridIcon',
      },
      {
        title: 'Buyer Return',
        route: 'buyer-return',
        icon: 'ArrowDownIcon', // <-- icon
      },
      {
        title: 'Expiry Label',
        route: 'expiry-label',
        icon: 'TagIcon',
      },
    ],
  },
  {
    header: 'Invoices',
    icon: 'BookIcon',
    group: 'invoices',
    children: [
      {
        title: 'Bilty ',
        route: 'bilty',
        icon: 'GridIcon',
      },
      {
        title: 'Invoices ',
        route: 'invoices',
        icon: 'ListIcon',
      },
      {
        title: 'Capital Goods',
        route: 'capital-goods-invoice',
        icon: 'InboxIcon',
      },
    ],
  },
  {
    header: 'Tickets',
    icon: 'ListIcon',
    group: 'tickets',
    children: [
      {
        title: 'Supplier Tickets ',
        route: 'supplier-tickets',
        icon: 'ClipboardIcon',
      },
      {
        title: 'Buyer Tickets ',
        route: 'buyer-tickets',
        icon: 'ClipboardIcon',
      },
    ],
  },
  {
    header: 'Stocks',
    icon: 'LayersIcon',
    group: 'stocks',
    children: [
      {
        title: 'Purchase Items Stock',
        route: 'purchase-items-stock',
        icon: 'CreditCardIcon',
      },
      {
        title: 'Verified Stock Reports',
        route: 'verified-stock-reports',
        icon: 'CheckSquareIcon',
      },
      {
        title: 'Minimum Quantity',
        route: 'minimum-quantity',
        icon: 'ShoppingBagIcon',
      },
    ],
  },
  {
    header: 'Delivery',
    icon: 'TruckIcon',
    group: 'delivery_admin',
    children: [
      {
        title: 'Access Management',
        route: 'delivery-access-management',
        icon: 'ToolIcon',
      },
      {
        title: 'Delivery Status',
        route: 'delivery-status',
        icon: 'UserCheckIcon',
      },
      {
        title: 'Delivery Dashboard',
        route: 'delivery-dashboard',
        icon: 'SunIcon',
      },
      {
        title: 'Bus Master',
        route: 'bus-master',
        icon: 'ListIcon',
      },
    ],
  },
  {
    header: 'Operations',
    icon: 'TrelloIcon',
    group: 'operations',
    children: [
      {
        title: 'RackGroup Reports',
        route: 'rack-group-reports',
        icon: 'FileTextIcon',
      },
      {
        title: 'Verify Order Items',
        route: 'verify-order-items',
        icon: 'CheckSquareIcon',
      },
      {
        title: 'Packing',
        route: 'packing',
        icon: 'PackageIcon',
      },
      {
        title: 'Operations Dashboard',
        route: 'operations-dashboard',
        icon: 'SunIcon',
      },
      {
        title: 'Cash Register',
        route: 'cash-register',
        icon: 'ServerIcon',
      },
    ],
  },
  {
    header: 'Retailers',
    icon: 'UsersIcon',
    group: 'retailer_admin',
    children: [
      {
        title: 'Retailers Insights',
        route: 'retailer-insights',
        icon: 'ZapIcon',
      },
      {
        title: 'Retailers Orders',
        route: 'retailer-orders',
        icon: 'PackageIcon',
      },
      {
        title: 'Banners',
        route: 'retailer-banners',
        icon: 'ImageIcon',
      },
      {
        title: 'Notifications',
        route: 'retailer-notifications',
        icon: 'BellIcon',
      },
      {
        title: 'Retailers Tickets',
        route: 'retailer-tickets',
        icon: 'ClipboardIcon',
      },
      {
        title: 'Retailer Shortage Items',
        route: 'retailer-shortage-items',
        icon: 'TrendingDownIcon',
      },
    ],
  },
  {
    header: 'Communication',
    icon: 'HeadphonesIcon',
    group: 'communications',
    children: [
      {
        title: 'Bulk Mailing',
        route: 'bulk-mailing-add',
        icon: 'MailIcon',
      },
      {
        title: 'Mail Templates',
        route: 'mail-templates',
        icon: 'LayersIcon',
      },
    ],
  },
]
